import React from 'react'
import Switch from 'components/ui/switch'
import Tooltip from 'components/ui/tooltip'
import styles from './index.module.css'

const EasyAccessSwitch = ({
  onClick,
  value,
  label = 'Easy access',
  tooltip = 'Easy access Catalogs mean you can download tracks from the Catalog.',
}: {
  onClick: (...args: Array<any>) => any
  value: boolean
  label?: string
  tooltip?: string
}): React.ReactNode => (
  <Tooltip content={tooltip}>
    <div className={styles.easyAccessSwitch} onClick={onClick}>
      <div>{label}</div>
      <span className={styles.easyAccessSwitchSwitch}>
        <Switch value={value} onChange={onClick} />
      </span>
    </div>
  </Tooltip>
)

export default EasyAccessSwitch
